export const FinancingQueryKey = {
  GET_LIST_BY_STOCK: 'GET_LIST_BY_STOCK',
  FINANCIAL_LIST: 'FINANCIAL_LIST',
};
